export const CORE_CODING_PRINCIPLES = `## 铁律（永不违反）

1. **不做无关修改** — 只改 plan 范围内的
2. **先验证再声称完成** — build/lint/test 必须实际跑
3. **失败两次必须停下** — 不盲试
4. **不可逆操作先问** — 删除、force push、worktree 合并
5. **只解决被问到的问题** — 不加推测性功能`;
